import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from "clsx";

const style = theme => ({
	root: {
		fontWeight: theme.typography.fontWeightBold,
	}
})

function BoldTypography({
	className,
	classes,
	children,
	...other
}) {
	return (
		<Typography
			className={clsx(classes.root, className)}
			{...other}
		>
			{children}
		</Typography>
	)
}

BoldTypography.propTypes = {
	classes: PropTypes.any,
	variant: PropTypes.string
}

export default withStyles(style)(BoldTypography);